var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { StyledIcon } from '../components/StyledIcon';
export var Down = forwardRef(function (props, ref) { return (_jsx(StyledIcon, __assign({ ref: ref, viewBox: "0 0 8 7", a11yTitle: "Down" }, props, { children: _jsx("path", { d: "M7.17311 1.64358C7.06858 1.47289 6.86453 1.3667 6.64013 1.3667H0.960469C0.736074 1.3667 0.532022 1.47289 0.427492 1.64358C0.32797 1.80638 0.334855 1.99763 0.445644 2.1548L3.28548 6.18687C3.39533 6.34348 3.5878 6.43671 3.8003 6.43671C4.0128 6.43671 4.20528 6.34348 4.31544 6.18715L7.15527 2.15509C7.26575 1.99763 7.27263 1.80638 7.17311 1.64358Z", fill: "#000" }) }))); });
//# sourceMappingURL=Down.js.map